import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_bin_lock_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  lock_type: fromDatatype.VarcharDatatypeInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  locked_qty: fromDatatype.NumericDatatypeInterface;
  locked_container_qty: fromDatatype.NumericDatatypeInterface;
  process_instance_line_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
}

export class bl_inv_bin_lock_RowClass implements bl_inv_bin_lock_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  lock_type: fromDatatype.VarcharDatatypeInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  locked_qty: fromDatatype.NumericDatatypeInterface;
  locked_container_qty: fromDatatype.NumericDatatypeInterface;
  process_instance_line_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
}